import React from "react";
import { View, } from "react-native";
import { Text } from "../Text/Text";
import { styles, colorStyles, borderColorStyles, } from "../Link/Link.styles";
export const LinkText = ({ color = "brand", underline = false, styles: userStyles, textStyles, children, ...rest }) => {
    return (React.createElement(View, { ...rest, style: [styles.container, userStyles] },
        React.createElement(View, { style: [underline && styles.underline, borderColorStyles[color]] },
            React.createElement(Text, { styles: [styles.linkText, colorStyles[color], textStyles] }, children))));
};
//# sourceMappingURL=LinkText.js.map